import React from "react";
import {
  UpDownElements,
  Star1,
  Star2,
  Star3,
  Star4,
  Star5,
  Letter1,
  Letter2,
  Letter3,
  Hexagon,
  ElementA,
  Zigzag,
  QuestionMark,
  Zigzag2,
  ExclamationMark,
} from "./MainScreenAnimations.styles";
import star1 from "../../assets/images/animations/star1.svg";
import star2 from "../../assets/images/animations/star2.svg";
import star3 from "../../assets/images/animations/star3.svg";
import letter1 from "../../assets/images/animations/letter1.svg";
import letter3 from "../../assets/images/animations/letter3.svg";
import hexagon from "../../assets/images/animations/hexagon.svg";
import upDownElements from "../../assets/images/animations/upDownElements.svg";
import elementA from "../../assets/images/animations/elementA.svg";
import zigzag from "../../assets/images/animations/zigzag.svg";
import questionMark from "../../assets/images/animations/questionMark.svg";
import zigzag2 from "../../assets/images/animations/zigzag2.svg";
import exclamationMark from "../../assets/images/animations/exclamationMark.svg";

const MainScreenAnimations = () => {
  return (
    <>
      <UpDownElements src={upDownElements} alt="up-down elements" />
      <Star1 src={star1} alt="rotating star1" />
      <Star2 src={star2} alt="rotating star2" />
      <Star3 src={star3} alt="rotating star3" />
      <Star4 src={star2} alt="rotating star4" />
      <Star5 src={star3} alt="rotating star5" />
      <Letter1 src={letter1} alt="letter1" />
      <Letter2 src={letter1} alt="letter2" />
      <Letter3 src={letter3} alt="letter3" />
      <Hexagon src={hexagon} alt="rotating hexagon" />
      <ElementA src={elementA} alt="element A" />
      <Zigzag src={zigzag} alt="zigzag" />
      <QuestionMark src={questionMark} alt="question mark" />
      <Zigzag2 src={zigzag2} alt="zigzag 2" />
      <ExclamationMark src={exclamationMark} alt="exclamation mark" />
    </>
  );
};

export default MainScreenAnimations;
